import { render } from "./JudgeHistory.vue?vue&type=template&id=14d74796&scoped=true"
import script from "./JudgeHistory.vue?vue&type=script&lang=js"
export * from "./JudgeHistory.vue?vue&type=script&lang=js"

import "./JudgeHistory.vue?vue&type=style&index=0&id=14d74796&lang=scss&scoped=true"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14d74796"]])

export default __exports__